// DO NOT EDIT this file was generated with scripts/IntrinsicElements
import * as React from "react";

export interface FuroBackdrop extends React.HTMLAttributes<HTMLElement> {
  onclosed?: (d: FuroBackdrop) => void;
  onopened?: (d: FuroBackdrop) => void;
  "onregister-backdrop"?: (d: FuroBackdrop) => void;
  // properties

  // attributes
  // no attributes defined.
}

declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      /**
       * `furo-backdrop`
       *
       * Displays content with a backdrop.
       *
       * The element you place in to furo-backdrop will be displayed centered.
       *
       *
       * ```html
       * <furo-backdrop at-opened="--BackdropFocus" at-closed="--backdropClosed"
       * fn-show="--expandIconClicked"
       * fn-close="--closeRequested, --recordSelected">
       * <any-component at-item-selected="--recordSelected" style="width: 90vw; height: 90vh"></any-component>
       * </furo-backdrop>
       *
       * ```
       *
       * You can wire and use the elements in furo-backrop as if they were local elements.
       *
       * Do not forget to add the furo-backdrop-display somewhere in the parent dom.
       */
      "furo-backdrop": FuroBackdrop;
    }
  }
}
